var _defs, _circle, _circle2, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconAzureVirtualDesktopStore = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-a37d3182-9086-4834-bc01-2817deb59175",
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 18 18",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-1d56e0b4-ddae-49ff-8d04-174a62b1adf3",
    x1: 14,
    y1: 767.516,
    x2: -4,
    y2: 785.516,
    gradientTransform: "translate(4 785.516) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c2c8cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-323ff70f-2270-4f05-8e26-d7849847749c",
    x1: 8.674,
    y1: 772.271,
    x2: 0.638,
    y2: 781.556,
    gradientTransform: "translate(4 785.516) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bf3207"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e25113"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-96f57530-2922-4c9b-8f3a-2cf9e272ea09",
    x1: 8.755,
    y1: 775.605,
    x2: 5.789,
    y2: 780.758,
    gradientTransform: "translate(4 785.516) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c2c8cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-3deaae87-fa70-4629-acbd-eb44677846c2",
    x1: 4.211,
    y1: 772.273,
    x2: 1.245,
    y2: 777.427,
    gradientTransform: "translate(4 785.516) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c2c8cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    fill: "url(#uuid-1d56e0b4-ddae-49ff-8d04-174a62b1adf3)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 7.5,
    fill: "url(#uuid-323ff70f-2270-4f05-8e26-d7849847749c)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.626,7.125l2.019-2.013c.139-.139,.139-.364,0-.503l-.757-.755c-.139-.139-.365-.139-.505,0l-3.029,3.019c-.139,.139-.139,.364,0,.503l3.029,3.019c.139,.139,.365,.139,.505,0l.757-.755c.139-.139,.139-.364,0-.503l-2.019-2.013Z",
    fill: "url(#uuid-96f57530-2922-4c9b-8f3a-2cf9e272ea09)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.112,7.604l-.757,.755c-.139,.139-.139,.364,0,.503l2.019,2.013-2.019,2.013c-.139,.139-.139,.364,0,.503l.757,.755c.139,.139,.365,.139,.505,0l3.029-3.019c.139-.139,.139-.364,0-.503l-3.029-3.019c-.139-.139-.365-.139-.505,0Z",
    fill: "url(#uuid-3deaae87-fa70-4629-acbd-eb44677846c2)"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconAzureVirtualDesktopStore);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Icon_Azure-Virtual-Desktop-Store.3c712b4679507486dc9a32f6639c688e.svg";